export const GUESS_COUNT = 3;
